export default __webpack_public_path__ + "static/media/noActiveCourses.71735273.png";